import type { RootState } from '$store';

// Root: Slice Selectors
export const selectRootState = (state: RootState) => state;
